<template>
    <div class="container">
        <div class="tipcomponent">
            <Tip v-if="props.showInfo" :tipMsg="['Hei olen Tringo! Neuvon sinua Trigenda® Digi työskentelyn aikana. Trigenda® työskentelyn tarkoitus on auttaa keskustelemaan juuri niistä asioista, joista on tarpeen puhua. Olen mukana neuvomassa kaikissa vaiheissa, saat minut esiin ja poistumaan infopainikkeesta. Työskentely etenee neljän vaiheen kautta. ',
            'Aloitetaan! Ensin valitaan Trigenda® sarja, jota tänään käytetään.']" :mood="'happy'" />
        </div>
        <div class="choisebox">
            <div class="choiceboxPadding">
                <div v-bind:class="{ feedback: deck.type == 'Palaute' }" class="datadiv" v-for="(deck, index) in decks" :key="index">
                    <div class="choise global-hover" @click="$emit('chosenDeck', index)">
                        <img src="../assets/ValintaPakka.png" alt="ValintaPakka">
                        <p class="deckname">{{ deck.name }}</p>
                        <p class="decktype">{{ deck.type }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import decks from "../decks.json";
import Tip from '../components/Tip.vue';

export default {
    name: "ChooseDeck",
    components: {
        Tip
    },
    props: {
        showInfo: Boolean
    },
    setup(props) {
        return { props, decks }
    },
    emits: ['chosenDeck'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.feedback {
    display: none !important;
}

.choisebox {
    position: relative;
    top: 5rem;
    width: 90%;
    background-color: var(--left);
    border-radius: 3px;
    margin: auto;
}

.deckname {
    font-size: 16px;
    margin-top: 4px;
    margin-bottom: 2px;
    color: cadetblue;
}

.decktype {
    margin-top: 2px;
    margin-bottom: 4px;
}

.choiceboxPadding {
    display: flex;
    flex-wrap: wrap;
    margin: auto;
    width: 90%;
    justify-content: center;
}

.container {
    background-image: url('../assets/tausta_blue.jpg');
    background-size: contain;
    height: 91.3vh;
}

.datadiv {
    width: 20%;
    margin: 20px 20px;
}

.choise {
    padding-top: 10px;
    padding-bottom: 10px;
    width: 100%;
}

.choise img {
    margin: 0 auto;
    width: 50%;
}

.tipcomponent {
    position: absolute;
    top: 0%;
    left: 0%;
}

@media only screen and (max-width: 1000px) {
    .choisebox {
        position: relative;
        top: 5%;
        width: 90%;
        border-radius: 3px;
        margin: auto;
        height: 80vh;
        overflow-y: scroll;
    }

    .choiceboxPadding {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 95%;
        justify-content: center;
    }

    .datadiv {
        padding: 0 20px;
        width: 30%;
    }

    .choise {
        padding: 5px 10px;
        width: 100%;
    }
}

@media only screen and (max-width: 700px) {
    .choisebox {
        position: relative;
        top: 6%;
        width: 90%;
        border-radius: 3px;
        margin: auto;
    }

    .choiceboxPadding {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 95%;
        justify-content: center;
    }

    .datadiv {
        margin: 10px 20px;
        width: 30%;
    }

    .choise {
        padding: 20px 5px;
        width: 100%;
    }
}

@media only screen and (max-width: 500px) {
    .choisebox {
        position: relative;
        top: 10%;
        width: 100%;
        border-radius: 3px;
        margin: auto;
    }

    .choiceboxPadding {
        display: flex;
        flex-wrap: wrap;
        margin: auto;
        width: 95%;
        justify-content: center;
    }

    .datadiv {
        padding: 5px 5px;
        width: 30%;
    }

    .choise {
        width: 100%;
    }
}
</style>